const locationIds = {
  STHLM: process.env.REACT_APP_ID_LOCATION_STHLM,
  GBG: process.env.REACT_APP_ID_LOCATION_GBG,
  MLM: process.env.REACT_APP_ID_LOCATION_MLM,
};

export default locationIds;
